// src/pages/MaintenancePage/MaintenancePage.js

import React, { useState, useEffect } from "react";
import {
  useNavigate,
  Routes,
  Route,
  useLocation,
  Outlet,
} from "react-router-dom";
import { getUser, logout, setUser } from "../../services/apiService";
import { OrbitLoaderComponent } from "../../utils/orbitLoader";
import { useNotifications } from "../../components/NotificationContext/NotificationContext";
import AdminPage from "../AdminPage/AdminPage";
import EmployeePage from "../EmployeePage/EmployeePage";
import Header from "../../components/Header/Header";
import "./MaintenancePage.css";

const MaintenancePage = () => {
  const [user, setUser] = useState(null);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentUser = getUser();
    if (!currentUser) {
      navigate("/login");
      return;
    }
    if (
      currentUser.role_name !== "maintenance_admin" &&
      currentUser.role_id !== 3
    ) {
      if (currentUser.role_name === "Admin" || currentUser.role_id === 1) {
        navigate("/admin");
      } else {
        navigate("/employee");
      }
      return;
    }
    setUser(currentUser);
  }, [navigate]);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
      navigate("/login", { replace: true });
    } catch (error) {
      console.error("Logout error:", error);
      navigate("/login", { replace: true });
    } finally {
      setIsLoggingOut(false);
    }
  };

  // Admin modunda giriş yapma fonksiyonu
  const handleAdminLogin = () => {
    const currentUser = getUser();
    if (currentUser) {
      const adminUser = {
        ...currentUser,
        role: "admin",
        role_name: "Admin",
        role_id: 1,
      };

      setUser(adminUser);
      localStorage.setItem("user", JSON.stringify(adminUser));
      navigate("/admin");
    }
  };

  // Çalışan modunda giriş yapma fonksiyonu
  const handleEmployeeLogin = () => {
    const currentUser = getUser();
    if (currentUser) {
      const employeeUser = {
        ...currentUser,
        role: "employee",
        role_name: "User",
        role_id: 2,
      };

      setUser(employeeUser);
      localStorage.setItem("user", JSON.stringify(employeeUser));
      navigate("/employee");
    }
  };

  if (!user) {
    return (
      <div className="maintenance-loading-container">
        <OrbitLoaderComponent size="medium" showPath={true} color="white" />
        <p>Yükleniyor...</p>
      </div>
    );
  }

  return (
    <div className="maintenance-container">
      <Header
        onLogout={handleLogout}
        userData={user}
        pageType="maintenance"
        isLoggingOut={isLoggingOut}
      />

      <div className="maintenance-content-full">
        <Routes>
          <Route
            path="/"
            element={
              <MaintenanceDashboard
                onAdminLogin={handleAdminLogin}
                onEmployeeLogin={handleEmployeeLogin}
              />
            }
          />
          <Route
            path="dashboard"
            element={
              <MaintenanceDashboard
                onAdminLogin={handleAdminLogin}
                onEmployeeLogin={handleEmployeeLogin}
              />
            }
          />
        </Routes>
      </div>
    </div>
  );
};

// Simplified Bakım Dashboard Bileşeni
const MaintenanceDashboard = ({ onAdminLogin, onEmployeeLogin }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="maintenance-loading-container">
        <OrbitLoaderComponent size="large" showPath={true} color="white" />
        <p>Sistem bilgileri yükleniyor...</p>
      </div>
    );
  }

  return (
    <div className="maintenance-dashboard-content">
      <div className="maintenance-dashboard-header">
        <h1>
          <i className="fas fa-tools"></i> Bakım Dashboard
        </h1>
        <p>Sistem yönetimi ve simülasyon modları</p>
      </div>

      {/* Simülasyon Modları Bölümü */}
      <div className="maintenance-login-section">
        <h2 className="maintenance-section-title">
          <i className="fas fa-sign-in-alt"></i> Simülasyon Modları
        </h2>
        <div className="maintenance-login-buttons">
          <div
            className="maintenance-login-button admin"
            onClick={onAdminLogin}
          >
            <div className="maintenance-login-icon">
              <i className="fas fa-user-shield"></i>
            </div>
            <div className="maintenance-login-content">
              <h3>Admin Olarak Giriş Yap</h3>
              <p>Yönetim panelini admin olarak kullan</p>
            </div>
            <div className="maintenance-login-arrow">
              <i className="fas fa-arrow-right"></i>
            </div>
          </div>

          <div
            className="maintenance-login-button employee"
            onClick={onEmployeeLogin}
          >
            <div className="maintenance-login-icon">
              <i className="fas fa-user"></i>
            </div>
            <div className="maintenance-login-content">
              <h3>Çalışan Olarak Giriş Yap</h3>
              <p>Çalışan panelini çalışan olarak kullan</p>
            </div>
            <div className="maintenance-login-arrow">
              <i className="fas fa-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
